export const SET_ENDS = 'SET_ENDS';
export const SET_END = 'SET_END';
export const ADD_END = 'ADD_END';
export const ADD_ENDS = 'ADD_ENDS';
export const UPDATE_END = 'UPDATE_END';
export const REMOVE_END = 'REMOVE_END';
export const CLEAR_END = 'CLEAR_END';
export const CLEAR_ENDS = 'CLEAR_ENDS';
